import './AlunoSite.css';
import { useState } from 'react';
import { Col, Card, CardTitle, Button, Row } from 'reactstrap';
import { QRCodeCanvas } from 'qrcode.react';

const AlunoSite = (props) => {
    const [alunoSelecionado, setAlunoSelecionado] = useState(JSON.parse(localStorage.getItem('alunoSelecionado')));

    const renderlistaResponsaveis = () => {
        let renderedList = [];
        for (let responsavel of alunoSelecionado.resposaveis) {
            renderedList.push(renderResponsavelSingle(responsavel));
        }
        return renderedList;
    }

    const renderResponsavelSingle = (responsavel) => {
        return (
            <>
                <div className="ResponsaveisCard">
                    <div className="ResponsaveisInfo">
                        Nome: {responsavel.nome}
                    </div>
                    <div className="ResponsaveisInfo">
                        Vínculo: {responsavel.vinculoFilial}
                    </div>
                    <div className="ResponsaveisInfo">
                        Autorização: {responsavel.autorizacao === 1 ? 'Autorizado(a)' : 'Não Autorizado(a)'}
                    </div>
                    <div className="ResponsaveisInfo">
                        Status: {responsavel.statusAtividad === 1 ? 'Ativo(a)' : 'Não Ativo(a)'}
                    </div>
                    <div>
                        <Button className="ButtonBater" onClick={() => props.marcarEntrada(responsavel["nome"], responsavel["vinculoFilial"], responsavel["cpfResponsavel"])}>
                            REGISTRO ENTRADA
                        </Button>
                        <Button className="ButtonBater" onClick={() => props.marcarSaida(responsavel["nome"], responsavel["vinculoFilial"], responsavel["cpfResponsavel"])}>
                            REGISTRO SAÍDA
                        </Button>
                    </div>
                </div>
            </>
        );
    }
    return (
        <div className="CardLocator">
            <div>
            <Card className="CardStyle" body>
                <CardTitle className="TitleStyleCard">
                    <div >
                            <QRCodeCanvas value={alunoSelecionado.cdAluno.toString()} />
                    </div>
                <div >
                            Nome: {alunoSelecionado.nome}
                </div>
                <div >
                            Turma: {alunoSelecionado.nomeTurma}
                </div>
                <div >
                            Unidade: {alunoSelecionado.nomeUnidade}
                </div>
                </CardTitle>
                <div className="DividerAlunoCard" />
                <div className="TitleStyle">
                    RESPONSÁVEIS
                </div>
                <div className="DividerAlunoCard" />
                <div className="TitleStyle">
                    {renderlistaResponsaveis()}
                </div>
                </Card>
            </div>
        </div>
    )
}

export default AlunoSite;